import styled from 'styled-components';

const getSpace = (x: number) => {
    return x * 4;
};

export const FormContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const FormContent = styled.div`
    padding: ${({ theme }) => getSpace(theme.x)}px;
    flex: 1;
`;

export const FormStepper = styled.div`
    padding: ${({ theme }) => getSpace(theme.x)}px;
`;

export const FormSummit = styled.div`
    padding: ${({ theme }) => getSpace(theme.x)}px;
`;
